exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.service-worker-update{line-height:80px;text-align:center;position:fixed;top:0;left:0;width:100%;background-color:rgba(0,0,0,.8);color:#fff;z-index:100\n}\n.service-worker-update span{float:right;margin-right:30px;cursor:pointer\n}", ""]);

// exports
